import { Button } from "@material-tailwind/react";
import DefaultLoading from "../common/DefaultLoading";

interface NextBackProps {
  shouldGoNext: boolean;
  next: () => void;
  back: () => void;
  shouldGoBack: boolean;
  isLoading: boolean;
}

NextBack.defaultProps = {
  shouldGoBack: true,
  isLoading: false,
};

function NextBack(props: NextBackProps) {
  return (
    <div className="drop-shadow-lg mt-20 flex p-4 bg-white justify-between  rounded-lg">
      <Button placeholder={undefined}
        variant="outlined"
        disabled={!props.shouldGoBack}
        onClick={() => props.back()}
      >
        back
      </Button>

      {props.isLoading ? (
        <DefaultLoading />
      ) : (
        <Button placeholder={undefined}
          onClick={() => props.next()}
          className="bg-primary"
          disabled={!props.shouldGoNext}
        >
          next
        </Button>
      )}
    </div>
  );
}

export default NextBack;
